import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { GetIssueExceptionResponse } from '../../../../shared/issuesV2';
import type { ErrorResponse } from '../../../ReactQuery';

//  Fetch a single issue exception by its ID.
const getIssueExceptionById = (id: number) => {
  return get<GetIssueExceptionResponse>(`/api/v2/issues/exceptions/${id}`);
};

const getQueryKey = (id: number): QueryKey => ['issues', 'exceptions', id];

/**
 * Fetches a single issue exception by its ID.
 * @param {number} id - The ID of the issue exception to fetch.
 * @returns {UseQueryResult<GetIssueExceptionResponse>} - The query result.
 */
export default function useIssueExceptionById(id: number, shouldFetch = true) {
  return useQuery<GetIssueExceptionResponse, ErrorResponse>({
    queryKey: getQueryKey(id),
    queryFn: () => getIssueExceptionById(id),
    //  We don't expect the issue exception to change frequently, so we can cache it for a bit longer than normal
    staleTime: 1000 * 10, //  10 seconds
    enabled: shouldFetch,
  });
}
